var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1D1D22",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.436 6c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54V13a3 3 0 0 0 0 6v4.436c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 0 1-.757-.756c-.16-.301-.252-.6-.265-1.345L0 19a3 3 0 0 0 0-6V8.564c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757.301-.16.6-.252 1.345-.265L29.436 6zm0 1.5-27.042.001c-.457.008-.551.029-.663.089a.319.319 0 0 0-.141.14c-.06.113-.085.225-.09.685v3.342l.112.04a4.502 4.502 0 0 1 2.883 3.991L4.5 16a4.502 4.502 0 0 1-2.888 4.203l-.112.039.001 3.364c.008.406.025.526.07.626l.019.037a.319.319 0 0 0 .14.141c.113.06.225.085.685.09h27.021c.586 0 .71-.024.833-.09a.319.319 0 0 0 .141-.14c.066-.124.09-.248.09-.834v-3.194l-.112-.04a4.502 4.502 0 0 1-2.883-3.99L27.5 16a4.502 4.502 0 0 1 2.888-4.203l.112-.04V8.564c0-.533-.02-.684-.073-.8l-.017-.033a.319.319 0 0 0-.14-.141c-.124-.066-.248-.09-.834-.09zM17.5 8.5h10.999a1 1 0 0 1 1 1l.001 1.503a.163.163 0 0 1-.051.119l-.037.026A5.5 5.5 0 0 0 26.5 16l.005.212a1 1 0 0 0 .002.046l.014.213a5.511 5.511 0 0 0 2.88 4.378c.06.03.099.092.099.16l-.001 1.49a1 1 0 0 1-1 1L17.5 23.5a1 1 0 0 1-.993-.883L16.5 22.5V9.499a1 1 0 0 1 .883-.993l.117-.007z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersIcon);
export default __webpack_public_path__ + "static/media/offers-icon.0bfc96438a8eb72bf4ac41225555409e.svg";
export { ForwardRef as ReactComponent };